import { render, staticRenderFns } from "./CreateRevButton.vue?vue&type=template&id=16bc3eff&scoped=true"
import script from "./CreateRevButton.vue?vue&type=script&lang=js"
export * from "./CreateRevButton.vue?vue&type=script&lang=js"
import style0 from "./CreateRevButton.vue?vue&type=style&index=0&id=16bc3eff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bc3eff",
  null
  
)

export default component.exports